import * as THREE from 'three'

var container

var colors = [0xE91E63, 0xC62828, 0xE040FB, 0xFFB74D, 0x673AB7]

var camera, scene, renderer

var obj = []

init()
animate()

function init () {
  container = document.createElement('div')
  container.className += 'polygon-circle'
  document.body.appendChild(container)

  camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 10000)
  camera.position.set(-600, 0, 0)

  scene = new THREE.Scene()

  var groundMaterial = new THREE.MeshPhongMaterial({
    color: 0x000000
  })

  var plane = new THREE.Mesh(new THREE.PlaneGeometry(15000, 10000), groundMaterial)
  plane.rotation.y = -Math.PI / 2
  plane.position.x = 500
  plane.receiveShadow = true

  scene.add(plane)

  scene.add(new THREE.AmbientLight(0xffffff))

  var light = new THREE.DirectionalLight(0x2e2e2e, 0.1)
  light.position.set(-1000, 0, 0)
  light.position.multiplyScalar(1.3)

  light.intensity = 1

  light.castShadow = true

  light.shadow.mapSize.width = 1000
  light.shadow.mapSize.height = 1000

  var d = 500

  light.shadow.camera.left = -d
  light.shadow.camera.right = d
  light.shadow.camera.top = d
  light.shadow.camera.bottom = -d

  light.shadow.camera.far = 4000

  scene.add(light)

  var group = new THREE.Group()
  scene.add(group)

  while (obj.length < 200) {
    var item = new Tetrahedron()
    obj.push(item)
  }

  for (var i = 0; i < obj.length; i++) {
    group.add(obj[i].shape)
  }

  renderer = new THREE.WebGLRenderer({antialias: true})
  renderer.shadowMap.enabled = true
  renderer.shadowMapSoft = true
  renderer.setClearColor(0xffffff, 1)
  renderer.setPixelRatio(window.devicePixelRatio)
  renderer.setSize(window.innerWidth, window.innerHeight)

  container.appendChild(renderer.domElement)

  window.addEventListener('resize', onWindowResize, false)
}

function onWindowResize () {
  camera.aspect = window.innerWidth / window.innerHeight
  camera.updateProjectionMatrix()

  renderer.setSize(window.innerWidth, window.innerHeight)
}

function animate () {
  requestAnimationFrame(animate)
  render()
}

function render () {
  camera.lookAt(scene.position)
  renderer.render(scene, camera)
  for (var i = 0; i < obj.length; i++) {
    obj[i].animate()
  }
}

function Tetrahedron () {
  this.size = Math.random()
  this.color = colors[Math.floor(Math.random() * colors.length)]
  this.geometry = new THREE.TetrahedronGeometry(this.size * 10, 0)
  this.material = new THREE.MeshLambertMaterial({
    color: this.color,
    flatShading: true
  })
  this.shape = new THREE.Mesh(this.geometry, this.material)
  this.shape.position.set(Math.floor(Math.random() * 150) + 300, 0, 0)
  this.circle_rotation = Math.random() * Math.PI * 2
  this.shape.castShadow = true
  this.shape.receiveShadow = true
  this.circle = Math.floor((Math.random() * 100) + 150)

  this.animate = function () {
    this.shape.position.y = Math.sin(this.circle_rotation) * this.circle
    this.shape.position.z = Math.cos(this.circle_rotation) * this.circle
    this.shape.rotation.x += this.size * 0.05
    this.shape.rotation.z += this.size * 0.05
    this.circle_rotation += 0.001
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/polygon-circle.js